import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {"position":"center-center","duration":4000,"theme":"toasted-primary","action":{"icon":"close","onClick":(e, toastObject) => {
        toastObject.goAway(0)
      }}})

export default function (ctx, inject) {
  inject('toast', Vue.toasted)
}